var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "12px",
    viewBox: "0 0 15 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82909666,8.90160188 L2.11834301,6.19084823 C1.81628761,5.88879282 1.33609696,5.88879282 1.03404155,6.19084823 C0.731986148,6.49290363 0.731986148,6.97309428 1.03404155,7.27514969 L4.27920092,10.5203091 C4.58125633,10.8223645 5.06919199,10.8223645 5.37124739,10.5203091 L13.5809584,2.31834301 C13.8830139,2.01628761 13.8830139,1.53609696 13.5809584,1.23404155 C13.278903,0.931986148 12.7987124,0.931986148 12.496657,1.23404155 L4.82909666,8.90160188 Z",
    id: "checkmark",
    stroke: "#BFD62F",
    fill: "#BFD62F",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.52918a19adb84628cdeb6ff9d2a155ca.svg";
export { ForwardRef as ReactComponent };